import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	factsContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.medium,

		[getFromBreakpoint('lg')]: {
			gap: theme.spacing.xlarge,
		},
	},
	factGroupContainer: {
		width: '100%',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		marginTop: theme.spacing.small,

		[getFromBreakpoint('lg')]: {
			flexDirection: 'row',
			justifyContent: 'space-between',
		},
	},
	factGroup: {
		boxSizing: 'border-box',
		'&:not(:last-child)': {
			marginBottom: theme.spacing.small,
		},

		[getFromBreakpoint('lg')]: {
			minWidth: '25%',
			'&:not(:last-child)': {
				paddingRight: theme.spacing.xxsmall,
				marginBottom: 0,
			},
		},
	},
	factHeading: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		cursor: 'pointer',
		color: theme.palette.neutral[70],
		'& > *': {
			pointerEvents: 'none',
		},
	},
	groupTitle: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xxsmall,
		color: theme.palette.neutral[70],
	},
	factList: {
		marginTop: theme.spacing.xxsmall,
		color: theme.palette.neutral[60],
		'&&': {
			marginBottom: 0,
			'& li': {
				marginBottom: 0,
				'&:not(:last-child)': {
					marginBottom: theme.spacing.tiny,
				},
				'&::after': {
					top: 10,
				},

				[getFromBreakpoint('lg')]: {
					font: theme.typography.bodyMd,
					'&::after': {
						top: 12,
					},
				},
			},
		},
	},
}));
